<template>
  <div class="container-fluid py-4 px-4">
    <div class="row no-gutters text-left">
      <div class="col-12">
        <div class="row justify-content-between">
          <div class="col-12 col-md-auto">
            <h4 class="font-weight-bold">VESSELS</h4>
          </div>
          <div class="col-12 col-md-auto">
            <form @submit.prevent="searchVessel">

              <div class="input-group input-group-sm mb-3">
                <div class="input-group-prepend">
                  <select class="form-control form-control-sm"
                          name="vesselType"
                          id="vessel-type"
                          v-model="formVesselData.vesselType"
                          style="font-size: 14px!important; width: 160px;">
                    <option :value="null">-- all --</option>
                    <option :value="vesselType.id" v-for="(vesselType,index) in objVesselTypeKeys" :key="vesselType.id">
                      <span v-if="vesselType.name">{{ vesselType.name.toLowerCase() }}</span>
                    </option>
                  </select>
                </div>
                <input class="form-control"
                       type="search"
                       placeholder="Search"
                       v-model="formVesselData.searchVal"
                       aria-label="Search">
                <div class="input-group-prepend">
                  <button type="submit" class="input-group-text rounded-right" id="basic-addon1">
                    &#128269;
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="col-12 col-md-auto">
            <div class="form-group form-inline">
              <label for="count-vessel" class="col-form-label font-weight-bold mr-3 py-0">Count:</label>
              <select class="form-control form-control-sm" name="countVessel" id="count-vessel"
                      v-model="formVesselData.count" @change="searchVessel">
                <option :value="count" v-for="(count,index) in counts" :key="index">
                  {{ count }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col-12 col-md-auto">
        <base-pagination :page-object="vesselPagination" @settingPage="setPage" />
      </div>
    </div>

    <div class="row no-gutters text-left">
      <div class="col-12">
        <base-table :loading="isLoading" :loader-colspan="4" :max-height="650">
          <template slot="table-header">
            <tr>
              <th style="width: 2% !important;">CODE</th>
              <th style="width: 25% !important;">NAME</th>
              <th style="width: 10% !important;">TYPE</th>
              <th style="width: 2% !important;" class="align-middle align-content-center">ACTION</th>
            </tr>
          </template>

          <template slot="table-body">
            <tr v-if="this.vessels.length == 0">
              <td colspan="4">No record found</td>
            </tr>
            <tr v-for="(vessel,index) in vessels" :key="vessel.id">
              <td class="text-center align-middle ml-3">
                <span v-if="vessel.code">{{ vessel.code.toUpperCase() }}</span>
              </td>
              <td class="text-left align-middle pl-4">{{ vessel.name ? vessel.name.toUpperCase() : '' }}</td>
              <td class="text-left align-middle pl-4">{{ vessel.type ? vessel.type.toUpperCase() : '' }}</td>
              <td>
                <base-info-btn @click.native="viewDetails(vessel.id)">
                  <font-awesome-icon icon="bars" />
                  <span class="ml-1">view</span>
                </base-info-btn>
              </td>
            </tr>
          </template>
        </base-table>
      </div>
    </div>
  </div>
</template>
<script>
import {AppMixins} from '../../../mixins/app.mixins';
import {mapActions, mapGetters} from 'vuex';
import BasePagination from '../../../components/base/BasePagination';

export default {
  name: 'index',
  components: {BasePagination},
  /** mixins **/
  mixins: [AppMixins],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {};
  },

  /** methods**/
  methods: {
    ...mapActions(
        [
          'getVesselPaginated',
          'getVesselTonRanks',
        ],
    ),

    loadData() {
      if (this.vessels.length == 0) {
        this.getVesselPaginated(this.formVesselData);
      }
    },

    setPage(e) {
      this.formVesselData.page = e;
      this.vesselPagination.currentPage = e;
      this.getVesselPaginated(this.formVesselData);
    },

    searchVessel() {
      this.formVesselData.page = 1;
      this.getVesselPaginated(this.formVesselData);
    },

    viewDetails(__vesselId) {
      this.getVesselTonRanks(__vesselId);
      this.$nextTick(() => {
        this.$router.push({name: 'VesselView', params: {vesselId: __vesselId}});
      });
    },
  },

  /**  computed  **/
  computed: {
    ...mapGetters(
        [
          'vessels',
          'vesselPagination',
          'objVesselTypeKeys',
          'formVesselData',
          'isLoading',
          'counts',
        ],
    ),
  },

  /** mounted **/
  mounted() {

  },

  /** created **/
  created() {
    this.loadData();
  },

  watch: {
    vessels: {
      handler: 'loadData',
      immediate: true,
    },
  },

  /** destroyed **/
  destroyed() {
  },

};
</script>

<style scoped>
.form-control-xs {
  height: calc(1.2em + 0.2rem + 1px) !important;
  padding: 0.23rem 0.3rem !important;
  font-size: 0.875rem !important;
  line-height: 1.3 !important;
  border-radius: 0.1rem !important;
}

#btn-search {
  background-color: #E9ECEF !important;
}
</style>
